import React, { type SyntheticEvent, type ReactNode } from 'react';
import { xcss, Pressable } from '@atlaskit/primitives';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { GIC_VIEW_NO_RESULTS_SOURCE } from '@atlassian/jira-issue-type-config-common/src/types.tsx';

type CreateWorkTypeButtonProps = {
	children: ReactNode;
	onClick: () => void;
	onMouseEnter: () => void;
};

export const CreateWorkTypeButton = ({
	children,
	onClick,
	onMouseEnter,
}: CreateWorkTypeButtonProps) => {
	const handleClick = (e: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'createIssueTypeButton', {
			calledFrom: GIC_VIEW_NO_RESULTS_SOURCE,
		});
		onClick();
	};

	return (
		<Pressable
			onClick={handleClick}
			onMouseEnter={onMouseEnter}
			xcss={createWorkTypeInlineNoResultStyles}
		>
			{children}
		</Pressable>
	);
};

const createWorkTypeInlineNoResultStyles = xcss({
	paddingBlockStart: 'space.0',
	paddingInline: 'space.0',
	marginTop: 'space.100',
	borderRadius: token('space.025'),
	color: 'color.link',
	backgroundColor: 'color.background.neutral.subtle',
	display: 'block',
	fontWeight: 'font.weight.bold',
});
